import type { CityConfig } from "../city-template/types";

export const yakimaConfig: CityConfig = {
  city: "Yakima",
  state: "Washington",
  stateAbbr: "WA",
  slug: "yakima",
  route: "/cities/yakima",
  title: "Emergency Passport Yakima WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Yakima, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Yakima, Selah, Union Gap, and all Yakima Valley residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Yakima, WA",
  heroSubtitle: "Yakima travelers — from orchard and wine country families to agricultural industry professionals to Central Washington families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of the Yakima Valley and Central Washington.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Yakima%20Washington%20in%20the%20Yakima%20Valley%20with%20surrounding%20orchards%20and%20vineyards%2C%20Mount%20Adams%20visible%20in%20the%20distance%2C%20the%20Yakima%20River%20winding%20through%20the%20valley%2C%20downtown%20Yakima%20with%20historic%20buildings%2C%20rows%20of%20apple%20and%20cherry%20orchards%20in%20full%20bloom%2C%20sunny%20high%20desert%20climate%20with%20blue%20skies%2C%20golden%20afternoon%20light%20over%20the%20agricultural%20landscape%2C%20Central%20Washington%20agricultural%20heartland%20atmosphere%2C%20professional%20photography%20without%20text%20or%20people&width=1800&height=700&seq=yakima-hero-001&orientation=landscape",
  heroImageAlt: "Yakima Washington Yakima Valley orchards and vineyards with Mount Adams",
  geoPosition: "46.6025;-120.5058",
  geoPlacename: "Yakima, Washington",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "300 5th Ave, Suite 600, Seattle, WA 98104",
    distance: "Approximately 140 miles west of Yakima via I-82/I-90",
  },
  nearbyCitiesZips: [
    { name: "Yakima", zips: "98901, 98902, 98903, 98904, 98908" },
    { name: "Selah", zips: "98942" },
    { name: "Union Gap", zips: "98903" },
    { name: "Terrace Heights", zips: "98901" },
    { name: "West Valley", zips: "98908" },
    { name: "Gleed", zips: "98904" },
    { name: "Naches", zips: "98937" },
    { name: "Tieton", zips: "98947" },
    { name: "Cowiche", zips: "98923" },
    { name: "Moxee", zips: "98936" },
    { name: "Wapato", zips: "98951" },
    { name: "Toppenish", zips: "98948" },
    { name: "Zillah", zips: "98953" },
    { name: "Granger", zips: "98932" },
    { name: "Sunnyside", zips: "98944" },
    { name: "Grandview", zips: "98930" },
    { name: "Prosser", zips: "99350" },
    { name: "Ellensburg", zips: "98926" },
    { name: "Cle Elum", zips: "98922" },
    { name: "Tri-Cities (Kennewick)", zips: "99336" },
    { name: "Goldendale", zips: "98620" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — cross-state courier from Central Washington" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for the Yakima Valley" },
    { icon: "ri-plant-line", title: "Yakima Valley Hub", desc: "Serving Yakima, Selah, Union Gap, Sunnyside, and all of Central Washington's agricultural communities" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Yakima or Union Gap location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Spokane, WA", route: "/cities/spokane" },
    { name: "Urgent passport services in Tri-Cities, WA", route: "/cities/kennewick" },
    { name: "Washington passport services overview", route: "/states/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Yakima, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (300 5th Ave, Suite 600, Seattle, WA 98104) — approximately 2.5 hours west via I-82 and I-90. Yakima residents can ship from any UPS or FedEx in the Yakima Valley.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Yakima, Selah, Union Gap, Terrace Heights, West Valley, Naches, Moxee, Wapato, Toppenish, Zillah, and all of the Yakima Valley",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Yakima and the Yakima Valley. From the historic downtown and the Capitol Theatre to the orchard-covered hillsides and the Yakima River canyon, from the agricultural communities of the Lower Valley to the families and wine industry professionals of Central Washington — we serve all of Yakima and Yakima County.",
  nearbyCitiesIntro: "We serve Yakima and all nearby communities including Selah, Union Gap, Terrace Heights, West Valley, Naches, Moxee, Wapato, Toppenish, Zillah, Granger, Sunnyside, Grandview, and Prosser. We also serve Ellensburg, Cle Elum, and the Tri-Cities.",
  howItWorksIntro: "Most Yakima travelers complete everything online and ship documents overnight. Yakima is 2.5 hours from Seattle across the Cascades via Snoqualmie Pass — our couriers handle the cross-mountain delivery so you never need to make that drive yourself.",
  mistakesIntro: "Yakima is the agricultural heart of Central Washington with a booming wine industry and growing international travel demand. Here are the most common passport mistakes we see from Yakima Valley travelers.",
  testimonialsIntro: "Yakima travelers — from orchard families to wine industry professionals to Central Washington residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Yakima, WA? Here are the most common ones we hear from Yakima Valley travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 2.5 hours across the Cascades to Seattle", "Snoqualmie Pass weather can close I-90 in winter"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — cross-mountain courier", "No Snoqualmie Pass drive or weather concerns", "Perfect for wine industry and agricultural travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — cross-mountain courier", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Yakima travelers with immediate departure needs — as fast as 24 hours. Our couriers handle the Seattle agency delivery. Perfect for wine industry conferences, agricultural trade shows, and Central Washington family emergencies.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — cross-mountain courier", "Wine and agricultural industry travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Yakima adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Yakima Valley address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Yakima residents and families — including orchard families, wine industry professionals, and Central Washington residents.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Yakima residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Yakima and Central Washington families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Yakima and Central Washington residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Yakima WA", description: "Urgent passport processing for Yakima Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Yakima WA", description: "Fast passport renewal for Yakima Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Yakima WA", description: "New passport application services for Yakima Washington residents applying for their first passport." },
    { name: "Child Passport Yakima WA", description: "Minor passport services for Yakima Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "Carlos M.",
      location: "Yakima, WA",
      rating: 5,
      text: "Wine industry conference in Bordeaux with 6 days notice and my passport was about to expire. Fast Passport Center had my renewed passport in 2 days. I shipped from UPS on Summitview Ave. Not having to deal with Snoqualmie Pass was incredible.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Maria & Jose G.",
      location: "Sunnyside, WA",
      rating: 5,
      text: "Family trip to Mexico with 10 days notice. Three passports — one adult renewal and two first-time for our kids. Done in 5 days. We shipped from FedEx in Yakima. Outstanding service for the Valley.",
      service: "Family Passport Bundle",
    },
    {
      name: "Tom H.",
      location: "Selah, WA",
      rating: 5,
      text: "Business trip to Tokyo with 8 days notice. Fast Passport Center walked me through everything and had my passport in 3 days. Living in the Yakima Valley, having a cross-mountain courier service is absolutely essential.",
      service: "Emergency Passport",
    },
    {
      name: "Linda R.",
      location: "Zillah, WA",
      rating: 5,
      text: "Lost my passport two weeks before a trip to Italy. Fast Passport Center replaced it in 4 days. The courier service is a must for anyone living in Central Washington — no need to cross the mountains.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "yak-1",
      name: "Yakima Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "205 W Washington Ave",
      city: "Yakima",
      state: "WA",
      zip: "98903",
      phone: "(509) 453-4615",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Yakima, near the Yakima Convention Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Yakima acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Yakima and the Capitol Theatre area.",
      icon: "ri-mail-line",
    },
    {
      id: "yak-2",
      name: "Sunnyside Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "713 E Edison Ave",
      city: "Sunnyside",
      state: "WA",
      zip: "98944",
      phone: "(509) 837-5540",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sunnyside, approximately 30 miles southeast of Yakima",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Sunnyside, Grandview, and Lower Yakima Valley residents. Good alternative for south Valley travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "yak-3",
      name: "Ellensburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E 3rd Ave",
      city: "Ellensburg",
      state: "WA",
      zip: "98926",
      phone: "(509) 925-1397",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ellensburg, approximately 40 miles north of Yakima via I-82",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Ellensburg, Kittitas Valley, and Central Washington University. Good alternative for north Yakima County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "yak-4",
      name: "Toppenish Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "14 Jefferson Ave",
      city: "Toppenish",
      state: "WA",
      zip: "98948",
      phone: "(509) 865-4555",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Toppenish, approximately 20 miles south of Yakima",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Toppenish, Wapato, Zillah, and Yakama Nation communities. Good alternative for lower Valley residents.",
      icon: "ri-mail-line",
    },
    {
      id: "yak-5",
      name: "Yakima County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "128 N 2nd St, Room 323",
      city: "Yakima",
      state: "WA",
      zip: "98901",
      phone: "(509) 574-2690",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Yakima Yakima County Courthouse",
      website: "https://www.yakimacounty.us/",
      websiteLabel: "Yakima County",
      notes: "Yakima County Clerk passport acceptance. Extended hours compared to post office. Convenient to downtown Yakima. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2.5-hour drive across Snoqualmie Pass to Seattle", fpc: "No — ship from Yakima" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Central WA Advantage", agency: "No special guidance", fpc: "Yes — Yakima Valley and wine industry expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Yakima wine industry professionals and agricultural workers often discover passport issues just before international conferences. Routine processing takes 6–13 weeks. For Yakima Valley residents 140 miles from the nearest passport agency, start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services on Summitview Avenue or at Valley Mall sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Yakima County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Yakima Post Office appointments fill during summer and agricultural harvest season. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Snoqualmie Pass — Winter Can Close I-90",
      description: "The Yakima-to-Seattle drive goes over Snoqualmie Pass (elevation 3,022 ft). Winter snow and ice can close I-90 or require chains. Never attempt a last-minute emergency drive across the Cascades — our courier service eliminates this risk entirely.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Wine industry travel to Europe and Latin America is year-round in the Yakima Valley — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Yakima Valley." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Yakima or Union Gap." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — no need to cross Snoqualmie Pass yourself." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Yakima address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Yakima, WA?", a: "Fast Passport Center offers emergency passport processing in Yakima, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (300 5th Ave, Suite 600, Seattle, WA 98104) — approximately 140 miles west via I-82 and I-90 over Snoqualmie Pass." },
    { q: "Is there a passport agency near Yakima?", a: "No — Yakima does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 2.5 hours west via I-82/I-90 over Snoqualmie Pass). Fast Passport Center's courier service is the practical solution for all of Central Washington." },
    { q: "Can I get an expedited passport in Selah, Sunnyside, or Toppenish?", a: "Absolutely. Fast Passport Center serves all of the Yakima Valley including Selah, Sunnyside, Toppenish, Grandview, Prosser, Wapato, Zillah, and all surrounding communities. Our service works the same way everywhere in Central Washington." },
    { q: "What airport do Yakima travelers use for international flights?", a: "Yakima Air Terminal (YKM) offers flights via Alaska Airlines with connections through Seattle. For international travel, most Yakima residents either fly from YKM connecting through SEA or drive 2.5 hours to Seattle-Tacoma International Airport. YKM is conveniently located just 10 minutes from downtown Yakima." },
    { q: "Does Fast Passport Center serve the Yakima Valley wine industry?", a: "Yes. Fast Passport Center serves all of Yakima County including the 90+ wineries and five AVAs that make the Yakima Valley Washington's premier wine region. We understand wine industry travel to Europe, South America, and international wine competitions. Our courier service is ideal for busy vintners and wine professionals." },
    { q: "How much does an expedited passport cost in Yakima, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Yakima?", a: "Walgreens, CVS, and Rite Aid stores throughout Yakima offer passport photos. UPS Store and FedEx Office locations also provide them. Locations on Summitview Ave and at Valley Mall offer walk-in service. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "What about Snoqualmie Pass in winter for Yakima passport travel?", a: "Snoqualmie Pass (I-90) is the main route from Yakima to Seattle. In winter, the pass can be closed or require chains. For this reason, attempting a last-minute emergency drive to the Seattle passport agency is especially risky from Yakima. Fast Passport Center's courier service eliminates this seasonal risk — we handle the mountain crossing for you regardless of weather." },
  ],
  photoLocations: [
    { name: "Walgreens — Summitview Ave", address: "4001 Summitview Ave, Yakima, WA 98908", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Rite Aid — Valley Mall", address: "2525 Main St, Union Gap, WA 98903", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Yakima Ave", address: "1212 N 39th Ave, Yakima, WA 98902", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Yakima", address: "2403 S 1st St, Yakima, WA 98903", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "WA DOL — Yakima", address: "1220 S 16th Ave, Yakima, WA 98902", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Sunnyside", address: "2010 Yakima Valley Hwy, Sunnyside, WA 98944", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Lower Yakima Valley. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "YKM",
      name: "Yakima Air Terminal — McAllister Field",
      distance: "10 minutes from downtown Yakima",
      address: "2400 W Washington Ave, Yakima, WA 98903",
      note: "Yakima's own airport with flights via Alaska Airlines connecting through Seattle-Tacoma International Airport. Convenient, easy parking, and short security lines. The gateway for Yakima Valley travelers heading anywhere in the world.",
      flightUrl: "https://www.yakimaairport.com/",
      flightLabel: "YKM Flight Info",
      featured: true,
    },
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "2.5 hours west of Yakima via I-82/I-90 over Snoqualmie Pass",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Major international gateway. Most Yakima travelers connect through SEA via YKM or drive directly. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: false,
    },
    {
      code: "PSC",
      name: "Tri-Cities Airport",
      distance: "Approximately 80 miles southeast of Yakima via I-82",
      address: "3601 N 20th Ave, Pasco, WA 99301",
      note: "Alternative airport for lower Yakima Valley residents. Alaska Airlines, Delta, United, and Allegiant serve PSC with connections through Seattle, Salt Lake City, Denver, and other hubs.",
      flightUrl: "https://www.flytricities.com/",
      flightLabel: "PSC Flight Info",
      featured: false,
    },
  ],
};